import React from "react";
import Input from "../../../../../../../components/Input";
import { remask } from "../../../../../../../libs/remask-mask";
import useEletronicInventoryStore from "../../store/useStore";

export default function RowFiveAndSix() {
  const { defaultValues } = useEletronicInventoryStore();
  const { saveDataOfField } = useEletronicInventoryStore();

  return (
    <>
      <div className="box-row">
        <Input
          name="memoryRam"
          label="Memória Ram"
          placeholder="Memória Ram"
          value={defaultValues?.memoryRam}
          setValue={(event) => saveDataOfField(event.target)}
        />
        <Input
          name="invoiceNumber"
          label="Nº Nota Fiscal"
          placeholder="Nota Fiscal"
          value={defaultValues?.invoiceNumber}
          setValue={(event) => saveDataOfField(event.target)}
        />
      </div>
      <div className="box-row">
        <Input
          name="purchasePrice"
          label="Valor do Item"
          placeholder="valor do Produto"
          value={defaultValues?.purchasePrice}
          setValue={(event) => saveDataOfField(event.target)}
        />
        <Input
          name="datePurchase"
          label="Data da Compra"
          placeholder="DD/MM/AAAA"
          value={remask(defaultValues?.datePurchase, ["99/99/9999"]) || defaultValues?.datePurchase}
          setValue={(event) => saveDataOfField(event.target)}
        />
      </div>
    </>
  );
}
